<template>
  <div ref="mainRef" class="account_menu_main_w bc_fff" @scroll="onScroll">
    <div
      class="div_13 bc_fff d_flex justify_content_sb align_item_c"
      :style="{ top: scrollTop + 'px' }"
    >
      <!-- <el-breadcrumb separator-class="el-icon-arrow-right">
        <el-breadcrumb-item>交易管理</el-breadcrumb-item>
        <el-breadcrumb-item>我的报名</el-breadcrumb-item>
      </el-breadcrumb> -->

      <div class="d_flex align_item_fe justify_content_sb div_11">
        <el-form ref="searchForm" :model="searchForm" size="small" inline>
          <el-form-item prop="title" class="form_item_1">
            <el-input v-model="searchForm.title" :maxlength="input_l_150" placeholder="项目名称" />
          </el-form-item>
          <el-form-item prop="state">
            <el-select
              v-model="searchForm.state"
              placeholder="报名结果"
              clearable
              @change="onStateChange"
            >
              <el-option
                v-for="item in stateList"
                :key="item.value"
                :label="item.label"
                :value="item.value"
              />
            </el-select>
          </el-form-item>

          <el-form-item class="form_item_2">
            <span>
              <el-button
                class="button_2"
                size="mini"
                type="primary"
                icon="el-icon-search"
                @click="onSearchClick"
              >查询</el-button>
              <el-button
                class="button_2"
                size="mini"
                type="primary"
                icon="el-icon-refresh-left"
                @click="onResetSearchForm"
              >重置</el-button>
            </span>
          </el-form-item>
        </el-form>
      </div>
    </div>

    <div v-if="dataRes.list && dataRes.list.length" class="div_14 bc_fff">
      <div
        v-for="item in dataRes.list"
        :key="item.id"
        class="d_flex div_8 justify_content_sb align_item_c"
      >
        <div class="d_flex">
          <div class="div_9">
            <div
              class="div_10 text_center c_fff fz12"
              :class="stateStyle(item.auctionState)"
            >
              {{ item.auctionStateDesc }}
            </div>
            <img
              class="img_1 cursor_pointer"
              :src="
                (item.cover || require('@/assets/images/QaKkPnoKQkBK7pdG.jpeg')) +
                  '!223'
              "
              alt=""
              @click="onGetProjectDetail(item.projectNo)"
            >
          </div>
          <div class="div_3 fz14">
            <ul>
              <li class="d_flex justify_content_sb li_1">
                <div class="d_flex">
                  <span class="c_808080">项目名称：</span>
                  <span class="c_1A1A1A span_1 text_ellipsis">{{
                    item.title
                  }}</span>
                </div>
                <div>
                  <span class="c_808080">开始时间：</span>
                  <span class="c_1A1A1A">{{ item.applyStartTime }}</span>
                </div>
              </li>
              <li class="d_flex justify_content_sb li_1">
                <div class="d_flex">
                  <span class="c_808080">项目编号：</span>
                  <span class="c_1A1A1A span_1 text_ellipsis">{{
                    item.projectNo
                  }}</span>
                </div>
                <div>
                  <span class="c_808080">结束时间：</span>
                  <span class="c_1A1A1A">{{ item.applyEndTime }}</span>
                </div>
              </li>
              <li class="d_flex justify_content_sb li_1">
                <div>
                  <span class="c_808080">审核状态：</span>
                  <span class="c_1A1A1A">{{ stateKey[item.state] }}</span>
                  <span
                    v-if="item.state === 2"
                    class="c_CF3342 span_2 cursor_pointer"
                    @click="onWatchSuggest(item.suggest)"
                  >查看原因</span>
                </div>
              </li>
            </ul>
          </div>
        </div>

        <div>
          <el-button
            class="button_1"
            @click="onGetProjectDetail(item.projectNo)"
          >查看详情</el-button>
        </div>

      </div>

      <div
        class="div_15 bc_fff d_flex align_item_c justify_content_c"
        :style="{ bottom: -scrollTop + 'px' }"
      >
        <!--分页-->
        <MyPagination
          :current-page="dataRes.pageNum"
          :total="dataRes.total"
          style="margin-top: 8px"
          change-method-name="getDataList"
          :that="this"
          layout="total, prev, pager, next, jumper"
          @current-change="scrollTop = 0"
        />
      </div>
    </div>

    <div v-else class="x_y_center" style="height: 100%">
      <img src="@/assets/images/empty_icon.png" alt="">
      <span style="margin: 0 0 0 10px">暂无数据</span>
    </div>

    <!-- 报名失败原因 -->
    <el-dialog title="审核详情" :visible.sync="suggestModal" width="700px">
      <div class="div_1">
        {{ suggestText }}
      </div>
    </el-dialog>
  </div>
</template>

<script>
import MyPagination from '@/components/base/MyPagination.vue'
import { user_applyList } from '@/api/action'
import {portal_user_applyList} from '@/api/portal'
import {
  _input_l_150,
  _input_l_300,
  _input_l_500 } from '@/utils/setting'
import { mapGetters } from 'vuex'
export default {
  components: {
    MyPagination
  },
  data() {
    return {
      scrollTop: 0,
      pageInfo: {
        page: 1,
        rows: 10
      },
      searchForm: {},
      dataRes: {},
      stateList: [
        {
          value: 0,
          label: '待审批'
        },
        {
          value: 1,
          label: '报名成功'
        },
        {
          value: 2,
          label: '报名失败'
        }
      ],
      stateKey: {
        0: '待审批',
        1: '报名成功',
        2: '报名失败'
      },

      suggestText: '', // 报名失败原因
      suggestModal: false
    }
  },
  computed: {
    ...mapGetters(['oss_pub_domain']),
    input_l_150() {
      return _input_l_150
    },
    input_l_300() {
      return _input_l_300
    },
    input_l_500() {
      return _input_l_500
    },
    // 报名结果状态样式
    applyResStyle: function() {
      return function(stateCode) {
        switch (stateCode) {
          case 0:
            return 'c_15A3C2'
          case 1:
            return 'c_15BD2D'
          case 2:
            return 'c_FF0006'
        }
      }
    },
    // 项目状态样式
    stateStyle: function() {
      return function(stateCode) {
        switch (stateCode) {
          // case 0:
          //   return 'bc_ccc'
          // case 1:
          //   return 'bc_2caeff'
          // case 2:
          //   return 'bc_8733CD'
          // case 3:
          //   return 'bc_FF9C00'
          // case 4:
          //   return 'bc_FC00FF'
          // case 5:
          //   return 'bc_FF0000'
          case 0:
          case 1:
            return 'bc_22D179'
          case 3 :
            return 'bc_EF3946'
          case 2:
          case 4:
          case 5:
            return 'bc_808080'
        }
      }
    }
  },
  created() {
    this.getDataList(this.pageInfo)
  },
  methods: {
    // 查看原因 click
    onWatchSuggest(suggest) {
      this.suggestText = suggest
      this.suggestModal = true
    },
    // 查看项目详情
    onGetProjectDetail(projectNo) {
      this.$router.push({
        name: 'tradeDetail',
        query: {
          projectNo
        }
      })
    },

    // 获取报名列表 api
    async getDataList(params) {
      const { data } = await portal_user_applyList(
        Object.assign(this.searchForm, params || this.pageInfo)
      )
      this.dataRes = data || {}
    },
    // 重置表单搜索
    onResetSearchForm() {
      this.searchForm = {}
      this.getDataList(this.pageInfo)
    },
    // 查询点击 click
    onSearchClick() {
      this.pageInfo.page = 1
      this.getDataList()
    },
    // 状态改变 change
    onStateChange(val) {
      this.getDataList(this.pageInfo)
    },
    onScroll() {
      this.scrollTop = this.$refs.mainRef.scrollTop
    }
  }
}
</script>

<style lang="scss" scoped>
.bc_ccc {
  background-color: rgba($color: #ccc, $alpha: 1);
}
.bc_2caeff {
  background-color: rgba($color: #2caeff, $alpha: 1);
}
.bc_8733CD {
  background-color: rgba($color: #8733cd, $alpha: 1);
}
.bc_FF9C00 {
  background-color: rgba($color: #ff9c00, $alpha: 1);
}
.bc_FC00FF {
  background-color: rgba($color: #fc00ff, $alpha: 1);
}
.bc_FF0000 {
  background-color: rgba($color: #ff0000, $alpha: 1);
}

.account_menu_main_w {
  position: relative;
  overflow-y: auto;
  width: 970px;
  min-height: 667px;
  box-sizing: border-box;
  border: 1px solid #dbdbdb;
  box-shadow: 0px 2px 6px 0px rgba(204, 204, 204, 0.6);
  &::-webkit-scrollbar {
    display: none;
  }
  & {
    scrollbar-width: none; //火狐
  }

  .img_1 {
    width: 223px;
    height: 134px;
  }
  .div_11 {
    // margin: 21px 0 0 0;
  }
  .div_12 {
    margin: 0 50px 0 0;
  }
  .div_13 {
    position: absolute;
    width: 100%;
    padding: 9px 20px;
    z-index: 1;
    box-sizing: border-box;
    border-bottom: 1px solid #dbdbdb;
    background-color: #e6e6e6;
  }
  .div_14 {
    padding: 52px 0 108px 0;
  }
  .div_15 {
    position: absolute;
    width: 100%;
    height: 108px;
  }

  .div_1 {
    min-height: 200px;
    text-indent: 30px;
  }
  .div_3 {
    width: 448px;
    margin: 0 0 0 18px;
    & > ul {
      margin: 16px 0 0 0;
    }
    .li_1 {
      margin: 0 0 30px 0;
      &:last-child {
        margin: 0;
      }
    }
  }
  .div_4 {
    margin: 0 48px 0 0;
  }

  .div_8 {
    margin: 0 20px;
    padding: 21px 0;
    border-bottom: 1px dashed #ccc;
  }
  .div_9 {
    overflow: hidden;

    position: relative;
  }
  .div_10 {
    position: absolute;
    top: 0;
    left: 0;
    width: 85px;
    height: 85px;
    line-height: 145px;
    transform: translate(-42.5px, -42.5px) rotateZ(-45deg);
  }
  .span_1 {
    display: inline-block;
    width: 134px;
  }
  .span_2 {
    margin: 0 0 0 10px;
  }

  .el-form-item.form_item_1 {
    margin: 0 16px 0 0;
  }
  .el-form-item.form_item_2 {
    margin: 0 0 0 16px;
  }

  ::v-deep .el-form-item {
    margin: 0;
    input {
      font-size: 14px;
      ::-webkit-input-placeholder {
        /* Chrome/Safari/Opera */
        font-size: 14px;
      }
      ::-moz-placeholder {
        /* Firefox 19+ */
        font-size: 14px;
      }
      // :-ms-input-placeholder {
      //   /* IE 10+ 注意这里只有一个冒号 */
      //   font-size: 14px;
      // }
    }
  }

  ::v-deep .el-icon-search {
    cursor: pointer;
  }
  .button_1 {
    padding: 7px 19px;
    background-color: #0983cc;
    border-color: #0983cc;
    color: #fff;
  }
  .button_2 {
    background-color: #0983cc;
    border-color: #0983cc;
    color: #fff;
  }
}
</style>
